var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({
        background: _vm.getCompany.color_background || _vm.$vuetify.theme.themes[_vm.theme].background,
        color: _vm.$vuetify.theme.themes[_vm.theme].color,
    })},[_c('app-bar',{attrs:{"side-bar-drawer":false}}),_c('base-view'),_c('c-snackbar'),_c('loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }